import api from './index'
// 查询faq列表
export const getFAQ = () => api.post('/commonQuestion/queryList')
export const getUserStatus = (data, headers) => api({
  url: '/vip/queryVipClose',
  data,
  method: 'POST',
  headers: headers
})
export const userWriteoff = (data, headers) => {
  return api({
  url: '/vip/action/close/apply',
  data,
  method: 'POST',
  headers: headers
})
}
